import { useState } from "react";
import { useList, useCreate, useRemove } from "@/hooks/crud";
import { ErrorBanner } from "@/components/Feedback";
import type { TrackTag } from "@/types/database";

export function TagsPanel({ trackId }: { trackId: number }) {
  const { data } = useList("track_tags", `track_id=eq.${trackId}&order=tag`);
  const tags = (data?.rows ?? []) as TrackTag[];
  const create = useCreate("track_tags");
  const remove = useRemove("track_tags");
  const [value, setValue] = useState("");

  async function add(e: React.FormEvent) {
    e.preventDefault();
    const tag = value.trim();
    if (!tag) return;
    await create.mutateAsync({ track_id: trackId, tag });
    setValue("");
  }

  return (
    <div className="panel">
      <div className="panel-head">
        <h3>Tags</h3>
        <span className="muted mono">{tags.length}</span>
      </div>
      <div className="panel-body">
        {create.error && <ErrorBanner error={create.error} />}
        <div style={{ marginBottom: 12 }}>
          {tags.length === 0 && <span className="muted">No tags.</span>}
          {tags.map((t) => (
            <span key={t.id} className="tag-chip">
              {t.tag}
              <button
                className="btn-ghost"
                style={{
                  border: "none",
                  background: "none",
                  color: "var(--ash)",
                  marginLeft: 4,
                  padding: 0,
                }}
                title="Remove"
                onClick={() => remove.mutate(t.id)}
              >
                ✕
              </button>
            </span>
          ))}
        </div>
        <form onSubmit={add} style={{ display: "flex", gap: 8 }}>
          <input
            placeholder="Add tag…"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <button className="btn btn-sm" type="submit" disabled={create.isPending}>
            Add
          </button>
        </form>
      </div>
    </div>
  );
}
